/* The one forma draft chip: Published / Pending publish / Saving… / Offline.
   Shared by the Master Forma Studio and the Designer's project forma
   (Sync appendix items 7 + 9 — same chip states in both). */
import React from 'react';
import { Check } from 'lucide-react';
import { Icon } from '../components/ui/Icon';
import { formaChipLabel, type FormaChipState } from './formaDraftModel';

export function FormaChip({ state, title }: { state: FormaChipState; title?: string }) {
  const tone =
    state === 'published'
      ? 'clean'
      : state === 'saving' || state === 'connecting'
        ? 'saving'
        : 'dirty';
  return (
    <span className={`dsg-save dsg-save-${tone}`} role="status" aria-live="polite" title={title}>
      {state === 'published' && <Icon icon={Check} em={1.0909} aria-hidden="true" />}
      {formaChipLabel(state)}
    </span>
  );
}
